import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Component_SL_Button, Component_SL_Header, Component_SL_Icon, Component_SL_Text } from '@app/styles/skeleton-loaders';
import { LL_H_C, LL_V_L } from '@nu-art/thunderstorm-frontend';
import './Component_AdvisorSL_Protocols.scss';
export const Component_SL_Protocol = () => {
    return _jsxs(LL_H_C, { className: 'c-asl-protocol', children: [_jsx(Component_SL_Text, { height: 12, width: 'random', variant: 'bold' }), _jsx(Component_SL_Button, { width: 100, height: 20 })] });
};
const SL_ProtocolGroup = () => {
    return _jsxs(LL_H_C, { className: 'c-asl-protocol-group', children: [_jsx(Component_SL_Header, { withSubtitle: true }), _jsx(Component_SL_Icon, {})] });
};
export const Component_AdvisorSL_Protocols = () => {
    return _jsxs(LL_V_L, { className: 'c-asl-protocols', children: [_jsx(Component_SL_Protocol, {}), _jsx(Component_SL_Protocol, {}), _jsx(Component_SL_Protocol, {}), _jsx(Component_SL_Protocol, {}), _jsx(SL_ProtocolGroup, {}), _jsx(SL_ProtocolGroup, {})] });
};
//# sourceMappingURL=Component_AdvisorSL_Protocols.js.map